const E503 = () => (
  <div className="error-container error-503">
    <h1>503</h1>
    <p className="title">Service Unavailable</p>
    <p>The server is currently unavailable (overloaded or down). Please try again later.</p>
  </div>
);

export default E503;